var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 36.57 77.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dce2ec;}.cls-2,.cls-3{fill:none;stroke:#727f89;stroke-miterlimit:10;}.cls-2{stroke-width:2px;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Poster_01b",
    "data-name": "Poster_01b",
    viewBox: "0 0 36.57 77.88"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 11.88 0 77.88 36.57 66 36.57 0 0 11.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.65,
    y1: 18.72,
    x2: 29.92,
    y2: 11.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6.65,
    y1: 27.72,
    x2: 29.92,
    y2: 20.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6.65,
    y1: 36.72,
    x2: 29.92,
    y2: 29.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.65,
    y1: 45.72,
    x2: 29.92,
    y2: 38.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6.65,
    y1: 54.72,
    x2: 29.92,
    y2: 47.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6.65,
    y1: 63.72,
    x2: 29.92,
    y2: 56.16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kontor_Lager",
    "data-name": "Kontor & Lager"
  }, /*#__PURE__*/React.createElement("use", {
    width: 36.57,
    height: 77.88,
    xlinkHref: "#Poster_01b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoster);
export default __webpack_public_path__ + "static/media/poster.3e45a608fc85f7434e2d8a7b8438b92a.svg";
export { ForwardRef as ReactComponent };